var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.activeLayout,{tag:"component"},[(!_vm.auth0Loading)?_c('router-view',{key:_vm.$route.path}):_vm._e(),_c('Notification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }